import { message } from "antd";
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  createHttpLink,
  split,
  from,
} from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import { setContext } from "@apollo/client/link/context";
import { WebSocketLink } from "@apollo/client/link/ws";
import {
  getMainDefinition,
  offsetLimitPagination,
} from "@apollo/client/utilities";

import { API_ENDPOINT, API_WS_ENDPOINT } from "config";
import { getLocalToken } from "shared/utils/util-funcs";
import { REFRESH_TOKEN } from "./shared/services/mutations";

/* ---- Handle gql and network errors, business logic errors are handled in component ---- */
//  graphQLErrors, networkError;
const errorLink = onError(({ operation, graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    console.log(
      "👉 ~ file: apollo-setup.js ~ line 25 ~ errorLink ~ graphQLErrors",
      graphQLErrors
    );
    graphQLErrors.forEach((err) => {
      // console.log(err.message); -- [Errno 111] Connection refused
      message.error(err?.message);
    });

    // message.error(`Something went wrong. Please refresh your page.`);
  } else if (networkError) {
    message.error(`Network error. Please refresh your page.`);
  }
});

// Custom fetch
const customFetch = (uri, options) => {
  let token = getLocalToken("auth");
  return fetch(uri, options);
};

/* ---- Apollo Client Setup ---- */
const wsLink = new WebSocketLink({
  uri: `wss://${API_WS_ENDPOINT}`,
  options: {
    reconnect: true,
  },
});

const httpLink = createHttpLink({
  uri: API_ENDPOINT,
  fetch: customFetch,
});

const authLink = setContext((_, { headers }) => {
  // get the authentication, lang token from local storage if it exists
  // const token =
  // "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoiMDIwZjhmNjktOGU5NS00NGNhLWIxNjgtNDA2MTAwOGIwMTBiIiwiZ3JvdXAiOiJ2aWRlb19jbGllbnQiLCJpZCI6ImVmYzkyNWMwLWNkNDQtNDE1OS05OGMyLTYwMTEzMDEyNGRjMyIsImV4cCI6MTYxNDQzNzA4MCwic3ViIjoiYWNjZXNzIn0.fxf3IubmkaOB_isufFzCq9d64V5Cml0AQOP8ilIp6C8";
  const token = getLocalToken("auth");
  let lang = getLocalToken("locale");

  // On local developement, english is default
  // if (["localhost", "127.0.0.1"].includes(window.location.hostname)) {
  //   lang = "en";
  // }

  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : "",
      "Accept-Language": lang ? lang : "jp",
    },
  };
});

const links = from([
  errorLink,
  split(
    ({ query }) => {
      const definition = getMainDefinition(query);
      return (
        definition.kind === "OperationDefinition" &&
        definition.operation === "subscription"
      );
    },
    wsLink,
    authLink.concat(httpLink)
  ),
]);

const client = new ApolloClient({
  link: links,
  cache: new InMemoryCache(),
});

export default function ApolloProviderSetup({ children }) {
  return <ApolloProvider client={client}>{children}</ApolloProvider>;
}
